import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { withRouter } from 'react-router';
import * as SurveyStateController from '../../../store/StateControllers/Survey/SurveyStateController';
import * as Models from '../../../store/Models/Surveys/SurveyDataModel';
import "./../styles.css";
import { SurveyProps } from '../CreateAndEditSurveys';
import { AcceptBomsContext } from '../../../store/Models/Api/AcceptBomsResponsesModels';
import { ToxnotReactComponentPaths } from '../../core/ToxnotReactComponentPaths';
import { Link } from 'react-router-dom';
import { ToxnotSignInRequiredComponent } from '../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../../store/Models/UserContext';
import { format, parseISO } from 'date-fns';
import { SurveyStatusManager } from '../../../store/Managers/SurveyStatusManager';
import SurveyMaterialsSection from './SectionsMaterials';

interface LocalState {
    responseDataJson: string | null;
}

class CreateAndEditSurveyStatusAndResponsesPage extends ToxnotSignInRequiredComponent<SurveyProps, LocalState>{
    private dateFormat = "yyyy-MM-dd";
    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }

    constructor(props: SurveyProps) {
        super(props);

        this.state = {
            responseDataJson: this.props.responseDataJson
        }
    }

    protected renderConcreteComponent() {
        const requestStateToDescriptionMap = [
            this.localizeString("Request Sent"),
            this.localizeString("In Progress"),
            this.localizeString("Response Received"),
            this.localizeString("Response Accepted"),
            this.localizeString("Draft"),
            this.localizeString("Response Partially Accepted"),
            this.localizeString("Revision Request Sent"),
            this.localizeString("Revision In Progress"),
            this.localizeString("Revision Response Received"),
            this.localizeString("Request Initiated"),
            this.localizeString("Revision Request Initiated"),
            this.localizeString("Customer Action")
        ];

        const isInStateOfBeingWorkedOnBySupplier = SurveyStatusManager.getWorkedOnBySuppliersState(this.props.surveyRequest.state);

        const surveyIsNotResolved = SurveyStatusManager.surveyIsNotResolved(this.props.surveyRequest.state);
        
        return (
            <div id="status-and-responses-root">
                <div className="status-container">
                    <p>
                        <label>{this.localizeString("Survey Status")}:</label> {requestStateToDescriptionMap[this.props.surveyRequest.state]} {!this.props.surveyRequest.requireValidationOnResponse ? `(${this.localizeString("Validation Disabled")})` : null}
                        {(SurveyStatusManager.surveyIsNotSentOrDraft(this.props.surveyRequest.state)) &&
                            <React.Fragment>
                                {" "}&bull;{" "}<label>{this.localizeString("Accepted by")}:</label> {this.props.surveyRequest.acceptedByName} {this.props.surveyRequest.acceptedByEmail}
                            </React.Fragment>
                        }
                        {(this.props.surveyRequest.reminderHistory.length > 0)
                            ? (
                                <React.Fragment>
                                    {" "}&bull;{" "}<label>{this.localizeString("Reminder(s) sent on")}:</label> {this.props.surveyRequest.reminderHistory.map(dateString => new Date(dateString).toLocaleDateString()).join(", ")}
                                </React.Fragment>
                            )
                            : (
                                <React.Fragment>
                                    {" "}&bull;{" "}<label>{this.localizeString("No Reminders Sent")}</label>
                                </React.Fragment>
                            )
                        }
                        {this.renderLastEditDate(isInStateOfBeingWorkedOnBySupplier)}
                    </p>
                    {surveyIsNotResolved && this.props.surveyRequest.notes[0]?.note != null &&
                        <p>
                            <label>{this.localizeString("Customer Action Notes")}:</label><br />
                            {this.props.surveyRequest.notes[0].note}
                        </p>
                    }
                    {isInStateOfBeingWorkedOnBySupplier &&
                        <p>
                            {this.localizeString("Link for Supplier to accept and open the survey:")}<br />
                            <code>{location.protocol + "//" + location.host + "/Surveys/DataCollectionRequestActivation?activationCode=" + encodeURIComponent(this.props.surveyRequest.activationCode)}</code>
                        </p>
                    }
                </div>
                {this.props.surveyRequest.responseHistoryList.length === 0
                    ? (
                        <p>
                            {this.localizeString("No responses have been received.")}
                        </p>
                    )
                    : this.renderResponseHistory()
                }
            </div>
        );
    }

    // ===============================================================================

    private renderLastEditDate(isInStateOfBeingWorkedOnBySupplier: boolean) {
        const { surveyRequest } = this.props;
        const responseData = this.props.responseDataJson ? JSON.parse(this.props.responseDataJson) : null;
        const requestData = surveyRequest.requestDataJson !== "" ? JSON.parse(surveyRequest.requestDataJson) : null;
        const lastEditDate = "LastEditDate";
        const acceptedByResponderDate = "AcceptedByResponderDate";

        if (responseData !== null && Object.keys(responseData).length !== 0 &&
                Object.keys(responseData).includes(lastEditDate)) {
            return (
                <>
                    {" "}&bull;{" "}<label>{this.localizeString("Last Edit Date")}:</label> {
                    new Date(responseData[lastEditDate]).toLocaleDateString() + ' ' + new Date(responseData[lastEditDate] + 'Z').toLocaleTimeString()
                    }
                </>
            );
        }
        else if (requestData !== null && Object.keys(requestData).length !== 0 &&
                Object.keys(requestData).includes(acceptedByResponderDate)) {
            return (
                <>
                    {" "}&bull;{" "}<label>{this.localizeString("Last Edit Date")}:</label> {
                    new Date(requestData[acceptedByResponderDate]).toLocaleDateString() + ' ' + new Date(requestData[acceptedByResponderDate] + 'Z').toLocaleTimeString()
                    }
                </>
            );
        }

        return null;
    }


    // ===============================================================================

    private renderResponseHistory() {
        return (
            <div className="response-history-list">
                {this.props.surveyRequest.responseHistoryList.map((historyEntry, historyEntryIndex) => (
                    (this.props.surveyUi.responseHistoryListIsExpanded || historyEntryIndex === 0)
                        ? this.renderResponseHistoryEntry(historyEntryIndex, historyEntry) 
                        : ((historyEntryIndex === 1) ? <div key={1}><button type="button" className="btn btn-default" onClick={e => this.props.setSurveyUIData({ responseHistoryListIsExpanded: true })}>{this.localizeString("Show Previous Responses")}</button></div> : null)
                ))
                }
            </div>
        );
    }

    // ===============================================================================

    private renderBomRevisionRequestInfo(historyEntryIndex: number, historyEntry: Models.SurveyRequestResponseHistoryEntry, responseInventoryId: string) {
        const bomRevisionRequest = this.props.surveyUi.revisionRequestManager!.getBomRevisionRequest(responseInventoryId);

        if (!bomRevisionRequest) {
            return null;
        }

        const contextStrings: string[] = [];

        if ((bomRevisionRequest.bomColumnRevisions.length > 0) ||
            (bomRevisionRequest.sustainabilityRevisionInstructions.length > 0) ||
            (bomRevisionRequest.circularityRevisionInstructions.length > 0) ||
            Object.values(bomRevisionRequest.dynamicRegulationRevisionInstructions).some(r => r.length > 0)) {
            contextStrings.push(this.localizeString("Material Content"));
        }

        if (bomRevisionRequest.bomQuestionnaireQuestionRevisions.length > 0) {
            contextStrings.push(this.localizeString("Questionnaire"));
        }

        if (bomRevisionRequest.attestationQuestionnaireQuestionRevisions.length > 0) {
            contextStrings.push(this.localizeString("Attestation Questionnaire"));
        }

        return (
            <div className="alert alert-warning">
                <p>
                    <b>{this.localizeString("Marked for Revision:")}</b> <span>{contextStrings.join(", ")}</span>
                </p>
                {historyEntryIndex === 0 &&
                    <p>
                        <a role="button" onClick={e => this.copyBomRevisionToSelectedMaterialsButton_click(historyEntry, responseInventoryId, bomRevisionRequest)}>{this.localizeString("Copy to all selected Materials")}</a>
                    </p>
                }
                <p>
                    {bomRevisionRequest.generalRevisionInstructions.coalesceToMaxSizeAndIndicateTruncationWithEllipsis(200) ?? ""}
                </p>
            </div>
        );
    }

    // ===============================================================================

    private renderResponseHistoryEntry(historyEntryIndex: number, historyEntry: Models.SurveyRequestResponseHistoryEntry) {
        const surveyRequest = this.props.surveyRequest;

        const allResponseDataAccepted = (historyEntry: Models.SurveyRequestResponseHistoryEntry) =>
            historyEntry.inventoryDataList.every(d => d.dateAccepted !== null) &&
            ((historyEntry.supplierQuestionnaireData === null) || (historyEntry.supplierQuestionnaireData.dateAccepted !== null));

        const allInventoriesHasRevisionRequestAndResponseReceived = (historyEntry: Models.SurveyRequestResponseHistoryEntry) =>
            historyEntry.inventoryDataList.every(d => d.revisionRequest != null && d.revisionRequest.dateRevisionResponseReceivedIso8601 !== null);

        const enterpriseSurveysEnabled = this.props.appServices.userContext?.userCapabilities.enterpriseSurveysEnabled ?? false;

        const requestCanBeRevised = [2, 5, 6, 8].includes(surveyRequest.state);

        const showMaterialData = surveyRequest.dataRequested.materialDisclosureAsked ||
            surveyRequest.dataRequested.complianceDataAsked ||
            surveyRequest.dataRequested.sustainabilityDataAsked ||
            surveyRequest.dataRequested.circularityDataAsked ||
            surveyRequest.dataRequested.documentsAsked;

        return (
            <div key={historyEntryIndex} className="response-history-entry">
                <div className="header">
                    <div className="date-received">
                        <b>{this.localizeString("Response received:")}</b> {new Date(historyEntry.dateReceived).toLocaleDateString() + ' ' + new Date(historyEntry.dateReceived).toLocaleTimeString()}
                    </div>
                    {(historyEntry.dateAccepted !== null) &&
                        <div className="date-accepted">
                            <b>{this.localizeString("Response accepted:")}</b> {new Date(historyEntry.dateAccepted).toLocaleDateString() + ' ' + new Date(historyEntry.dateAccepted).toLocaleTimeString()}
                        </div>
                    }
                    {((historyEntryIndex === 0) && !allResponseDataAccepted(historyEntry) && this.props.appServices.userContext?.isEditor) &&
                        <div className="action">
                            <button type="button" className="btn btn-warning" disabled={this.props.surveyRequest.state == 1 ? true : false} title={this.props.surveyRequest.state == 1 ? this.localizeString("Revisions cannot be requested for unsubmitted surveys.") : ""} onClick={e => this.sendRevisionRequestButton_click(historyEntry.historyId)}>{this.localizeString("Send a Revision Request")}</button>
                        </div>
                    }
                </div>
                <div className="response-body">
                    {(enterpriseSurveysEnabled && (historyEntry.dateRevisionSent !== null)) &&
                        <div className="response-body-section">
                            <div className="alert alert-warning">
                                {this.localizeString("Revision Request Sent:")} {new Date(historyEntry.dateRevisionSent).toLocaleDateString() + ' ' + new Date(historyEntry.dateRevisionSent).toLocaleTimeString()}
                                {" "}
                                {(historyEntry.dateRevisionResponseReceived !== null) && <React.Fragment>{this.localizeString("Revision Response Received:")} {new Date(historyEntry.dateRevisionResponseReceived).toLocaleDateString() + ' ' + new Date(historyEntry.dateRevisionResponseReceived).toLocaleTimeString()}</React.Fragment>}
                                {" "}
                                <a role="button" onClick={e => this.props.setSurveyUIData({ viewGranularRevisionRequestHistoryEntryId: historyEntry.historyId })}>{this.localizeString("View Revision Request Details")}</a>
                            </div>
                        </div>
                    }
                    {(historyEntry.supplierQuestionnaireData !== null) &&
                        <div className="response-body-section">
                            <div className="title">{this.localizeString("Supplier-level Questionnaire Response")}</div>
                            <div>
                                <div className="material-response-row">
                                    <div className="top align-center">
                                        <div className="material-name">
                                            {historyEntry.supplierQuestionnaireData.questionnaire?.name.emptyCoalesce(this.localizeString("Unnamed"))}
                                        </div>
                                        <div className="material-response-links-container">
                                            <a href={`/Surveys/QuestionnaireResponse?requestId=${encodeURIComponent(surveyRequest.requestId ?? "")}&historyId=${encodeURIComponent(historyEntry.historyId)}`}>{this.localizeString("View Questionnaire Response")}</a>
                                        </div>
                                    <div className="material-actions">
                                            {this.props.appServices.userContext?.isEditor && (enterpriseSurveysEnabled && (historyEntryIndex === 0) && requestCanBeRevised) &&
                                                <a href={`/Surveys/QuestionnaireResponse?requestId=${encodeURIComponent(surveyRequest.requestId ?? "")}&historyId=${encodeURIComponent(historyEntry.historyId)}`} className="btn btn-sm btn-default"><span className="glyphicon glyphicon-pencil"></span> {this.localizeString("Revisions")}</a>
                                            }
                                            {this.props.appServices.userContext?.isEditor && <button type="button" className="btn btn-sm btn-toxnot-primary" onClick={e => this.acceptSupplierLevelResponseButton_click(historyEntry)}>{(historyEntry.supplierQuestionnaireData.dateAccepted === null) ? this.localizeString("Accept") : this.localizeString("Re-accept")}</button>}
                                        </div>
                                    </div>
                                    <div className="bottom">
                                        {(enterpriseSurveysEnabled && this.props.surveyUi.revisionRequestManager!.supplierQuestionnaireIsMarkedForRevision()) &&
                                            <div className="alert alert-warning">
                                                <p>
                                                    <b>{this.localizeString("Marked for Revision:")}</b>
                                                </p>
                                                <p>
                                                    {this.props.surveyUi.revisionRequestManager?.getSupplierQuestionnaireRevisionRequest()?.generalRevisionInstructions.coalesceToMaxSizeAndIndicateTruncationWithEllipsis(200) ?? ""}
                                                </p>
                                            </div>
                                        }
                                        {(historyEntry.supplierQuestionnaireData.dateAccepted !== null) &&
                                            <div className="alert alert-success">{this.localizeString("Accepted:")} {new Date(historyEntry.supplierQuestionnaireData.dateAccepted).toLocaleDateString() + ' ' + new Date(historyEntry.supplierQuestionnaireData.dateAccepted).toLocaleTimeString()}</div>
                                        }
                                        {(enterpriseSurveysEnabled && (historyEntry.supplierQuestionnaireData.revisionRequest !== null)) &&
                                            <div className="alert alert-info">
                                                {(historyEntry.supplierQuestionnaireData.revisionRequest.dateSentIso8601 !== null) &&
                                                    <React.Fragment>
                                                        {this.localizeString("Revision Request Sent:")} {new Date(historyEntry.supplierQuestionnaireData.revisionRequest.dateSentIso8601).toLocaleDateString() + ' ' + new Date(historyEntry.supplierQuestionnaireData.revisionRequest.dateSentIso8601).toLocaleTimeString()}
                                                        {" "}
                                                    </React.Fragment>
                                                }
                                                {(historyEntry.supplierQuestionnaireData.revisionRequest.dateRevisionResponseReceivedIso8601 !== null)
                                                    ? `${this.localizeString("Response Received:")} ${new Date(historyEntry.supplierQuestionnaireData.revisionRequest.dateRevisionResponseReceivedIso8601).toLocaleDateString()} ${new Date(historyEntry.supplierQuestionnaireData.revisionRequest.dateRevisionResponseReceivedIso8601).toLocaleTimeString()}`
                                                    : this.localizeString("Waiting for response")
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {(historyEntry.offlineResponseData !== null) &&
                        <div className="response-body-section">
                            <div className="title">Offline Response Data</div>
                            <div>
                                <div className="top align-center">
                                    <div className="material-name">
                                        <label>{this.props.appServices.localizeString("Supplier Response Text:")}</label>
                                        <p>{historyEntry.offlineResponseData.supplierResponseText}</p>
                                    </div>
                                    <div className="material-name">
                                        <label>{this.props.appServices.localizeString("Notes:")}</label>
                                        <p>{historyEntry.offlineResponseData.notes}</p>
                                    </div>
                                    <div className="material-response-links-container">
                                        <label>{this.props.appServices.localizeString("Attached Files:")}</label>
                                        <div>
                                            {historyEntry.offlineResponseData.fileIds.map((v, i) =>
                                                <a key={i} href={"Api/GeneralFile?fileId=" + encodeURIComponent(v)}>{this.props.surveyMetadata.offlineResponseFileTable[v].filename + ", "}</a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {this.props.appServices.userContext?.isEditor && <div className="bottom">
                                    <button type="button" className="btn btn-sm btn-toxnot-default" onClick={e => this.bulkEditSummaryDataButton_click(e)}>{this.localizeString("Edit Questionnaire data for all the Materials in this Survey")}</button>
                                </div>}
                            </div>
                        </div>
                    }
                    {(historyEntry.inventoryDataList.length > 0) &&
                        <div className="response-body-section">
                            {this.renderMaterialResponses(historyEntry, 
                                showMaterialData, 
                                requestCanBeRevised, 
                                enterpriseSurveysEnabled, 
                                surveyRequest, 
                                historyEntryIndex
                            )}      
                        </div>
                    }
                </div>
            </div>
        );
    }

    private getInventoryValidationStatus = (responseInventoryId: string) => {
        if (this.props.surveyMetadata?.responseInventoryMetadataTable &&
            this.props.surveyMetadata.responseInventoryMetadataTable[responseInventoryId] &&
            this.props.surveyMetadata.responseInventoryMetadataTable[responseInventoryId].inventoryValidationStatus !== undefined) {

            return this.props.surveyMetadata.responseInventoryMetadataTable[responseInventoryId].inventoryValidationStatus;
        }
        return null;
    }
    private renderMaterialResponses = (historyEntry: Models.SurveyRequestResponseHistoryEntry, 
        showMaterialData: boolean | undefined, 
        requestCanBeRevised: boolean, 
        enterpriseSurveysEnabled: boolean, 
        surveyRequest: Models.SurveyRequest, 
        historyEntryIndex: number) => {

        // Separate available and unavailable materials
        const availableMaterials: Models.SurveyRequestResponseHistoryInventoryData[] = [];
        const unavailableMaterials: Models.SurveyRequestResponseHistoryInventoryData[] = [];
        
        historyEntry.inventoryDataList
            .orderBy((inv: Models.SurveyRequestResponseHistoryInventoryData) => {
                const metadata = this.props.surveyMetadata.responseInventoryMetadataTable[inv.responseInventoryId];
                return metadata ? metadata.inventoryName : '';
            }).forEach((responseInventoryData: any) => {
                const validationStatus = this.getInventoryValidationStatus(
                    responseInventoryData.responseInventoryId
                );

                // if validation status is
                // "NoLongerAvailable": "2",
                // "NeverSold": "3"
                // than that material is consider as unavailable materials
                if (validationStatus && ["2","3"].includes(validationStatus.toString())) {
                    unavailableMaterials.push(responseInventoryData);
                } else {
                    availableMaterials.push(responseInventoryData);
                }
            });
        return (
            <div id="response-page-survey-materials-section">
                <SurveyMaterialsSection
                    availableMaterials={availableMaterials}
                    unavailableMaterials={unavailableMaterials}
                    appServices={this.props.appServices}
                    surveyMetadata={this.props.surveyMetadata}
                    historyEntry={historyEntry}
                    selectAllMaterials={this.selectAllMaterialsCheckbox_change}
                    acceptSelectedMaterials={this.acceptSelectedBomResponsesButton_click}
                    renderAvailblematerials= {
                        () => (
                            <div className="available-materials">
                                {availableMaterials.map((responseInventoryData: Models.SurveyRequestResponseHistoryInventoryData, responseInventoryDataIndex) => (
                                    <div key={responseInventoryDataIndex} className="material-response-row">
                                        <div className="top align-center">
                                            <div className="material-name">
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox" className="material-name-checkbox" data-history-entry-id={historyEntry.historyId} data-response-inventory-id={responseInventoryData.responseInventoryId} disabled={!this.props.appServices.userContext?.isEditor || (this.props.surveyMetadata.offlineProcessQueuedMaterials.includes(responseInventoryData.responseInventoryId) ? true: false)} /> {this.props.surveyMetadata?.responseInventoryMetadataTable[responseInventoryData.responseInventoryId]?.inventoryName}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="material-response-links-container">
                                                {showMaterialData &&
                                                    <div>
                                                        {(responseInventoryData.responseSharedMaterialId !== null) && <Link to={ToxnotReactComponentPaths.SharedMaterialBaseDetailPath + `/${encodeURIComponent(responseInventoryData.responseSharedMaterialId)}`}>{this.localizeString("View Material Passport Response")}</Link>}
                                                        {(responseInventoryData.responseSharedMaterialId === null) && (
                                                            <>
                                                                {(responseInventoryData.responseSharedMaterialId !== null) ? " - " : ""}
                                                                <a href={`/Data/Inventory?requestId=${encodeURIComponent(this.props.surveyRequest.requestId!)}&requestHistoryEntryId=${encodeURIComponent(historyEntry.historyId)}&inventoryId=${encodeURIComponent(responseInventoryData.responseInventoryId)}&mode=ViewSurveyManufacturerResponseBom`}>{this.localizeString("Material Response")}</a>
                                                            </>
                                                            )}
                                                    </div>}
                                                {(surveyRequest.bomQuestionnaireId !== null) &&
                                                    <div>
                                                        <a href={`/Surveys/QuestionnaireResponse?requestId=${encodeURIComponent(surveyRequest.requestId ?? "")}&historyId=${encodeURIComponent(historyEntry.historyId)}&inventoryId=${responseInventoryData.responseInventoryId}`}>{this.props.surveyMetadata.questionnaireTable[surveyRequest.bomQuestionnaireId]?.name ?? "Unknown Questionnaire"}</a>
                                                    </div>
                                                }
                                                {(surveyRequest.attestationQuestionnaireId !== null) &&
                                                    <div>
                                                        <a href={`/Surveys/QuestionnaireResponse?requestId=${encodeURIComponent(surveyRequest.requestId ?? "")}&historyId=${encodeURIComponent(historyEntry.historyId)}&inventoryId=${responseInventoryData.responseInventoryId}&useAttestationQuestionnaire=True`}>{this.props.surveyMetadata.questionnaireTable[surveyRequest.attestationQuestionnaireId]?.name ?? "Attestation Questionnaire"}</a>
                                                    </div>
                                                }
                                                {this.hasSdsMetadata(this.props.surveyMetadata.responseInventoryMetadataTable[responseInventoryData.responseInventoryId]?.sdsMetadata) && (
                                                    this.generateMultipleSdsLinks(
                                                        responseInventoryData.responseInventoryId,
                                                        this.props.surveyMetadata.responseInventoryMetadataTable[responseInventoryData.responseInventoryId].sdsMetadata
                                                    )
                                                )}
                                            </div>
                                            {this.props.appServices.userContext?.isEditor && <div className="material-actions">
                                                {(enterpriseSurveysEnabled && (historyEntryIndex === 0) && requestCanBeRevised) &&
                                                    (responseInventoryData.revisionRequest === null || (responseInventoryData.revisionRequest !== null && responseInventoryData.revisionRequest.dateRevisionResponseReceivedIso8601 !== null)) &&
                                                    <a href={`/Data/Inventory?requestId=${encodeURIComponent(surveyRequest.requestId ?? "")}&requestHistoryEntryId=${encodeURIComponent(historyEntry.historyId)}&inventoryId=${encodeURIComponent(responseInventoryData.responseInventoryId)}&mode=ViewSurveyManufacturerResponseBom`} className={`btn btn-sm btn-default ${this.props.surveyMetadata?.extensionRequest?.inventoryIds?.some(i => i === responseInventoryData.responseInventoryId) ? "disabled" : ""}`}><span className="glyphicon glyphicon-pencil"></span> {this.localizeString("Revisions")}</a>
                                                }
                                                {this.props.appServices.userContext?.userCapabilities.lifecycleStatusEnabled
                                                    ? (
                                                        <div className="btn-group">
                                                            <button type="button" disabled={this.props.surveyMetadata.offlineProcessQueuedMaterials.indexOf(responseInventoryData.responseInventoryId) > -1 ? true : false} className="btn btn-sm btn-toxnot-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                {(responseInventoryData.dateAccepted !== null) ? this.localizeString("Re-accept") : this.localizeString("Accept")}
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-right">
                                                                <li><a role="button" onClick={e => this.acceptBomResponseButton_click(historyEntry, responseInventoryData, false)}>{(responseInventoryData.dateAccepted !== null) ? this.localizeString("Re-accept") : this.localizeString("Accept")}</a></li>
                                                                <li><a role="button" onClick={e => this.acceptBomResponseButton_click(historyEntry, responseInventoryData, true)}>{(responseInventoryData.dateAccepted !== null) ? this.localizeString("Re-accept and Mark as Approved") : this.localizeString("Accept and Mark as Approved")}</a></li>
                                                            </ul>
                                                        </div>
                                                    )
                                                    : (
                                                        <button type="button" className="btn btn-sm btn-toxnot-primary" onClick={e => this.acceptBomResponseButton_click(historyEntry, responseInventoryData, false)}>{(responseInventoryData.dateAccepted !== null) ? this.localizeString("Re-accept") : this.localizeString("Accept")}</button>
                                                    )
                                                }
                                            </div>}
                                        </div>
                                        <div className="bottom">
                                            {(enterpriseSurveysEnabled && this.props.surveyUi.revisionRequestManager!.bomIsMarkedForRevision(responseInventoryData.responseInventoryId)) &&
                                                this.renderBomRevisionRequestInfo(historyEntryIndex, historyEntry, responseInventoryData.responseInventoryId)
                                            }
                                            {(responseInventoryData.dateAccepted !== null) &&
                                                <div className="alert alert-success">
                                                    {this.localizeString("Accepted:")} {new Date(responseInventoryData.dateAccepted).toLocaleDateString() + ' ' + new Date(responseInventoryData.dateAccepted).toLocaleTimeString()}
                                                </div>
                                            }
                                            {(enterpriseSurveysEnabled && (responseInventoryData.revisionRequest !== null)) &&
                                                <div className="alert alert-info">
                                                    {(responseInventoryData.revisionRequest.dateSentIso8601 !== null) &&
                                                        <React.Fragment>
                                                            {this.localizeString("Revision Request Sent:")} {new Date(responseInventoryData.revisionRequest.dateSentIso8601).toLocaleDateString() + ' ' + new Date(responseInventoryData.revisionRequest.dateSentIso8601).toLocaleTimeString()}
                                                            {" "}
                                                        </React.Fragment>
                                                    }
                                                    {(responseInventoryData.revisionRequest.dateRevisionResponseReceivedIso8601 !== null)
                                                        ? `${this.localizeString("Response Received:")} ${new Date(responseInventoryData.revisionRequest.dateRevisionResponseReceivedIso8601).toLocaleDateString()} ${new Date(responseInventoryData.revisionRequest.dateRevisionResponseReceivedIso8601).toLocaleTimeString()}`
                                                        : this.localizeString("Waiting for Response")
                                                    }
                                                </div>
                                            }
                                        </div>
            
                                        {this.props.surveyMetadata.extensionRequest?.inventoryIds.some(i => i === responseInventoryData.responseInventoryId) &&
                                            <div>
                                                {this.localizeString(`Supplier requested extension until ${format(parseISO(this.props.surveyMetadata?.extensionRequest.extensionDate ?? ""), this.dateFormat)}`)}
                                                {this.props.surveyMetadata?.extensionRequest?.comment && 
                                                    <div>{`Extension Request comment: ${this.props.surveyMetadata?.extensionRequest?.comment}`}</div>}
                                            </div>
                                        }
                                    </div>
                                ))}
                            </div>
                        )
                    }
                />            
            </div>
        );
    }

    private hasSdsMetadata(sdsMetadataItem: Models.SurveyResponseInventorySdsMetadata[] | null | undefined): boolean {
        return (
            sdsMetadataItem !== null && sdsMetadataItem !== undefined && sdsMetadataItem.length > 0
        );
    }
    
    private isSingleSdsMetadata(sdsMetadataItem: Models.SurveyResponseInventorySdsMetadata[]): boolean {
        return (
            sdsMetadataItem.length === 1
        );
    }
    
    private generateSdsUrl(inventoryId: string, sdsMetadataItem: Models.SurveyResponseInventorySdsMetadata): string {
        return sdsMetadataItem.documentId > 0
            ? sdsMetadataItem.documentUrl
            : `/Api/InventoryFile?inventoryId=${encodeURIComponent(inventoryId)}&fileId=${encodeURIComponent(sdsMetadataItem.fileId!)}&attachment=False`;
    }
    
    private generateMultipleSdsLinks(inventoryId: string, sdsMetadata: Models.SurveyResponseInventorySdsMetadata[]) {
        if (this.isSingleSdsMetadata(sdsMetadata)) {
            const url = this.generateSdsUrl(inventoryId, sdsMetadata[0]);
            return (
                <div>
                    <div className="title">
                        <a type="button" href={url} target="_blank">
                            {this.localizeString("View SDS")}
                        </a>
                    </div>
                </div>
            );
        }
    
        return (
            <div>
                <div className="title">
                    <a
                        type="button"
                        id={`sds-inventory-${inventoryId}`}
                        onClick={() => this.viewSdsSectionGroupTitle_click(inventoryId)}
                    >
                        <span className="glyphicon glyphicon-chevron-up"></span>{' '}
                        {this.localizeString("View SDSs")}
                    </a>
                </div>
                <div className="content inherited-tree initially-hidden">
                    <ul>
                        {sdsMetadata.map((sds, index) => (
                            <li key={index}>
                                <a href={this.generateSdsUrl(inventoryId, sds)} target="_blank">
                                    {sds.fileName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
    

    private viewSdsSectionGroupTitle_click = (inventoryId: string) => {
        // Select the button by its id using jQuery
        const $button = $(`#sds-inventory-${inventoryId}`);

        // Toggle the glyphicon class on the span within the button
        const $glyph = $button.find('span');

        // Toggle the content visibility and the glyphicon classes
        const $content = $button.closest(".title").next(".content");

        $content.toggle();

        if ($glyph.hasClass("glyphicon-chevron-up")) {
            $glyph.removeClass("glyphicon-chevron-up");
            $glyph.addClass("glyphicon-chevron-down");
        }
        else {
            $glyph.addClass("glyphicon-chevron-up");
            $glyph.removeClass("glyphicon-chevron-down");
        }
    }
    
    // ===============================================================================

    private copyBomRevisionToSelectedMaterialsButton_click = (historyEntry: Models.SurveyRequestResponseHistoryEntry, sourceResponseInventoryId: string, bomRevisionRequest: Models.BomRevisionRequest) => {
        const $selectedCheckboxes = $(`.material-name-checkbox[data-history-entry-id="${historyEntry.historyId}"]:checked`);

        if ($selectedCheckboxes.length === 0) {
            alert(this.localizeString("Please select at least one Material."));
            return;
        }

        const selectedResponseInventoryIds: string[] = [];

        $selectedCheckboxes.each((index, element) => {
            selectedResponseInventoryIds.push($(element).data("response-inventory-id").toString());
        });

        if (selectedResponseInventoryIds.some(id => this.props.surveyMetadata?.extensionRequest?.inventoryIds?.some(i => i === id))) {
            alert(this.localizeString("You cannot add a revision for materials with an extension request. Please unselected all the materials having an extension request and try again."))
        }else {
            this.props.surveyUi.revisionRequestManager!.copyBomRevisionToOtherBoms(sourceResponseInventoryId, selectedResponseInventoryIds);

            this.props.refreshRevisionRequestData();
        }
    }

    // ===============================================================================

    private sendRevisionRequestButton_click = (historyEntryId: string) => {
        if (!this.props.appServices.userContext?.userCapabilities.enterpriseSurveysEnabled ?? false) {
            // Only general requests supported

            this.initiateGeneralRevisionRequestModal();
        }

        if ((this.props.surveyUi.revisionRequestManager === null) || this.props.surveyUi.revisionRequestManager.activeRequestIsEmpty()) {
            // no existing requests configured... see if the user wants to send a general revision
            // request, or to edit the revision request before sending

            $("#empty-granular-revision-requests-modal").modal("show");
        }
        else {
            // found a granular revision request config... go to the UI for sending the
            // request
            this.props.setSurveyUIData({
                sendGranularRevisionRequestMode: true
            });
        }
    }

    // ===============================================================================

    private initiateGeneralRevisionRequestModal() {
        const $modal = $("#ask-for-general-revision-modal");

        $modal.find("#revision-message-textarea").val("").closest(".form-group").show();
        $modal.find(".modal-body .alert").hide();
        $modal.find("#submit-revision-cancel-button").show();
        $modal.find("#submit-revision-submit-button").show();
        $modal.find("#submit-revision-done-button").hide();

        $modal.modal("show");
    }

    // ===============================================================================

    private acceptSupplierLevelResponseButton_click = (historyEntry: Models.SurveyRequestResponseHistoryEntry) => {
        this.initiateAcceptSupplierLevelResponseModal(historyEntry.historyId);
    }

    // ========================================================================

    private bulkEditSummaryDataButton_click = (e: any) => {
        const selectedInventoryIds = this.props.surveyRequest.requestInventoryMetadataList.map(md => md.inventoryId);

        const $submissionForm = $('<form action="/Data/BulkEditSummaryData" method="POST"></form>');

        $submissionForm.append('<input type="hidden" name="source" value="survey" />');

        for (let selectedInventoryId of selectedInventoryIds) {
            $submissionForm.append('<input type="hidden" name="inventoryIds" value="' + encodeURIComponent(selectedInventoryId) + '" />');
        }

        if (this.props.surveyRequest.bomQuestionnaireId !== null) {
            $submissionForm.append('<input type="hidden" name="questionnaireIds" value="' + encodeURIComponent(this.props.surveyRequest.bomQuestionnaireId) + '" />');
        }

        $(document.body).append($submissionForm);

        $submissionForm.submit();
        $submissionForm.remove();
    }

    // ===============================================================================

    private selectAllMaterialsCheckbox_change = (historyEntry: Models.SurveyRequestResponseHistoryEntry, checked: boolean) => {
        const $checkboxes = $(`.material-name-checkbox[data-history-entry-id="${historyEntry.historyId}"]`);

        for (var i = 0; i < $checkboxes.length; i++) {
            let invId = $checkboxes.eq(i).data("response-inventory-id");

            if (this.props.surveyMetadata.offlineProcessQueuedMaterials.indexOf(invId) === -1) {
                $checkboxes.eq(i).prop("checked", checked);
            }
        }
    }

    // ===============================================================================

    private acceptSelectedBomResponsesButton_click = (historyEntry: Models.SurveyRequestResponseHistoryEntry, shouldMarkAsApproved: boolean) => {
        
        const $selectedCheckboxes = $(`.material-name-checkbox[data-history-entry-id="${historyEntry.historyId}"]:checked`);

        if ($selectedCheckboxes.length === 0) {
            alert(this.localizeString("Please select at least one material in the response."));
            return;
        }

        const selectedResponseInventoryIds: string[] = [];

        $selectedCheckboxes.each((index, element) => {
            selectedResponseInventoryIds.push($(element).data("response-inventory-id").toString());
        });

        const responseInventoriesToAccept = historyEntry.inventoryDataList.filter(inv => selectedResponseInventoryIds.includes(inv.responseInventoryId));

        this.initiateAcceptBomResponsesModal(historyEntry, responseInventoriesToAccept, shouldMarkAsApproved);
    }

    // ===============================================================================

    private acceptBomResponseButton_click = (historyEntry: Models.SurveyRequestResponseHistoryEntry, responseInventoryData: Models.SurveyRequestResponseHistoryInventoryData, shouldMarkAsApproved: boolean) => {
        this.initiateAcceptBomResponsesModal(historyEntry, [responseInventoryData], shouldMarkAsApproved);
    }

    // ===============================================================================

    /**
     * kicks off the workflow for accepting the response to a supplier-level questionnaire
     * 
     * @param historyId the history containing the response to accept
     */
    private initiateAcceptSupplierLevelResponseModal(historyId: string) {
        const $modal = $("#accept-supplier-response-modal");

        $modal.find(".close").show();
        $modal.find(".alert").hide();
        $modal.find("#accept-supplier-response-cancel-button").show();
        $modal.find("#accept-supplier-response-confirm-button").prop("disabled", false).show();
        $modal.find("#accept-supplier-response-done-button").hide();

        $modal.data("history-id", historyId);

        $modal.modal("show");

        return $modal;
    }

    // ===============================================================================

    private initiateAcceptBomResponsesModal(historyEntry: Models.SurveyRequestResponseHistoryEntry, inventoriesToAccept: Models.SurveyRequestResponseHistoryInventoryData[], shouldMarkAsApproved: boolean) {
        const $modal = $("#accept-bom-responses-modal");

        $modal.find('input[type="radio"]').prop("checked", false);
        $("#accept-response-radio-overwrite-original").prop("checked", true);
        $modal.find(".close").show();
        $modal.find(".accept-bom-responses-shared-container").hide();
        $modal.find(".accept-bom-responses-normal-container").hide();
        $modal.find(".accept-bom-responses-open-container").hide();
        $modal.find(".alert").hide();
        $modal.find("#accept-bom-responses-cancel-button").show();
        $modal.find("#accept-bom-responses-confirm-button").show();
        $modal.find("#accept-bom-responses-done-button").hide();

        $("#accept-bom-responses-radio-overwrite-original").prop("checked", true);
        $("#accept-bom-responses-radio-save-copy").prop("checked", false);

        const context: AcceptBomsContext = {
            historyId: historyEntry.historyId,
            inventoriesToAccept: inventoriesToAccept,
            shouldMarkAsApproved: shouldMarkAsApproved
        };

        $modal.data("accept-boms-context", context);

        if (this.props.surveyRequest.bomType === 0 && inventoriesToAccept.every(inv => inv.targetInventoryId !== null)) {
            $modal.find(".accept-bom-responses-normal-container").show();
        }
        else if (this.props.surveyRequest.bomType === 1) {
            // open bom
            $modal.find(".accept-bom-responses-open-container").show();
        }
        else {
            // no bom data
            $modal.find(".accept-bom-responses-open-container").show();
        }

        $modal.modal("show");
    }

}


export default connect(
    (state: ApplicationState) => ({ ...state.createAndEditSurveysState, appServices: state.appServices }),
    SurveyStateController.actionCreators
)(withRouter(CreateAndEditSurveyStatusAndResponsesPage) as any);
